/** @format */

import { HeaderCheckBoxSelectListElement } from '../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';

/** @format */

export class PlusNotifyHelper {
    public static notificationType = (type: string): string => {
        switch (type) {
            case '64':
                return 'prov:list.threholdamount';
            case '72':
                return 'prov:list.consumption_of_funds_in_the_package';
            case '35':
                return 'prov:list.funnel';
            case '34':
                return 'prov:list.one_shot_package';
            case '27':
                return 'prov:list.cyclic_package_activate';
            case '23':
                return 'prov:list.expiry_package';
            case '9':
                return 'prov:list.package_off';
            case '-666':
                return 'prov:list.fup_packages';
            default:
                return 'general:common.no_translation';
        }
    };

    public static notificationGroupType = (type: string | number): string => {
        switch (type) {
            case 1:
            case '1':
                return 'prov:list.fup_packages';
            case 2:
            case '2':
                return 'prov:list.packages';
            case 3:
            case '3':
                return 'prov:list.thresholds';
            default:
                return 'general:common.no_translation';
        }
    };

    public static notificationGroupTypesList = (): Array<HeaderCheckBoxSelectListElement> => {
        let items = new Array<HeaderCheckBoxSelectListElement>();
        items = [
            { name: 'prov:list.fup_packages', value: 1 },
            { name: 'prov:list.packages', value: 2 },
            { name: 'prov:list.thresholds', value: 3 },
        ];

        return items;
    };

    public static notificationTypesList = (): Array<HeaderCheckBoxSelectListElement> => {
        let items = new Array<HeaderCheckBoxSelectListElement>();
        items = [
            { name: 'prov:list.threholdamount', value: 64 },
            { name: 'prov:list.consumption_of_funds_in_the_package', value: 72 },
            { name: 'prov:list.funnel', value: 35 },
            { name: 'prov:list.one_shot_package', value: 34 },
            { name: 'prov:list.cyclic_package_activate', value: 27 },
            { name: 'prov:list.expiry_package', value: 23 },
            { name: 'prov:list.package_off', value: 9 },
            { name: 'prov:list.fup_packages', value: -666 },
        ];

        return items;
    };

    public static notificationDirectionList = (): Array<HeaderCheckBoxSelectListElement> => {
        let items = new Array<HeaderCheckBoxSelectListElement>();
        items = [
            { name: 'prov:list.UP', value: 1 },
            { name: 'prov:list.DOWN', value: 2 },
            { name: 'prov:list.NONE', value: 3 },

        ];

        return items;
    };

    public static threholdamount = (value: string, type: string): string => {
        if (value === 'DOWN' && type === '64') {
            return 'prov:list.threholdamount_down';
        }
        if (value === 'UP' && type === '64') {
            return 'prov:list.threholdamount_up';
        }
        return '';
    };
}
